import { useApiUtils } from 'x1-base/composables';
import { useCustomFetch } from '~/composables';
import type { NitroFetchOptions } from 'nitropack';
import type {
    Review,
    ReviewSubmitResponse,
    ReviewSummary
} from '~/types';
import type {
    PaginatedPayload,
    CustomPagination,
    PaginatedRequest
} from 'x1-base/types';
import { merge as lo_mergeCompat } from 'es-toolkit/compat';
import { omit as lo_omit } from 'es-toolkit';
import type { NuxtError } from '#app';

export function useReview() {
    const apiBasePath = `/v1/reviews`;
    const useApiUtilsObj = useApiUtils();
    const $_fetch = useCustomFetch();

    // TODO: Maybe use getPagedListItems instead
    async function getReviews(
        args: PaginatedRequest = {},
        query: NitroFetchOptions<string>['query'] = {}
    ): Promise<[PaginatedPayload<Review>, ReviewSummary] | Error> {
        const url = args?.url ?? `${apiBasePath}/`;

        const config: NitroFetchOptions<string> = {
            method: 'GET',
            query: {}
        };

        lo_mergeCompat(config.query, args?.params, query, {
            // Base params here
        });

        let paginatedPayload: PaginatedPayload<Review>;

        try {
            const response = await $_fetch<CustomPagination<Review> & { summary: ReviewSummary }>(url, config);

            paginatedPayload = {
                pagination: lo_omit(response, ['results', 'summary']),
                data: response.results
            };

            return [paginatedPayload, response.summary];
        } catch (err) {
            return useApiUtilsObj.getErrorObj(err);
        }
    }
    
    async function createReview(reviewObj: Review): Promise<ReviewSubmitResponse | NuxtError> {
        const url = `${apiBasePath}/`;
        const config: NitroFetchOptions<string> = {
            method: 'POST',
            body: reviewObj
        };

        try {
            return await $_fetch<ReviewSubmitResponse>(url, config);
        } catch (err) {
            return useApiUtilsObj.getNuxtErrorObj(err);
        }
    }
    
    return {
        getReviews,
        createReview
    };
}
